// removed by extract-text-webpack-plugin
module.exports = {"header":"index__header__1JD7j"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 115
// module chunks = 0